import { z } from "zod";
export const filterSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string(),
});
export type GroupId = string;
export type Filter = z.infer<typeof filterSchema>;
export type FilterGroupState = Record<GroupId, Filter[]>;
